// extracted by mini-css-extract-plugin
module.exports = {"error":"input_error__error___3N_yb _type__vx_text-6_lighter___2qDBi","centered":"input_error__centered___3_jxd","red":"input_error__red___1ebn9"};